// Mirrors backend/doc_filename.py — adds the ISO week a document covers to its file name.
import { isoYear } from './weekFilter';
import { weekNo } from './dateFormat';

const DOC_EXT = /\.(pdf|xlsx|xls|csv|docx)$/i;
const HAS_TAG = /\d{4}-W\d{1,2}(?!\d)/;
const DATE = /(?<![\dA-Za-z])(\d{4})[-_.](\d{2})[-_.](\d{2})(?:T\d{2}[-:]?\d{2}(?:[-:]?\d{2})?)?(?!\d)/g;
const COMPACT = /(?<![\dA-Za-z])((?:19|20)\d{2})(\d{2})(\d{2})(?:[_T]\d{4,6})?(?![\d-])/g;
const MONTH = /(?<![\dA-Za-z])(\d{4})[-_](\d{2})(?![-_.]?\d)/g;
const JOIN = /\0[^A-Za-z0-9\0]*(?:(?:to|do|until)[^A-Za-z0-9\0]+)?\0/i;

const valid = (y, m, d = '01') => {
  const dt = new Date(Number(y), Number(m) - 1, Number(d));
  return dt.getMonth() === Number(m) - 1 && dt.getDate() === Number(d) ? dt : null;
};

const tag = (days) => {
  const keys = [...new Set(days.map((d) => isoYear(d) * 100 + weekNo(d)))].sort((a, b) => a - b);
  const [y1, w1, y2, w2] = [Math.floor(keys[0] / 100), keys[0] % 100, Math.floor(keys.at(-1) / 100), keys.at(-1) % 100];
  if (keys.length === 1 || (y1 === y2 && w1 === w2)) return `${y1}-W${w1}`;
  return y1 === y2 ? `${y1}-W${w1}-W${w2}` : `${y1}-W${w1}-${y2}-W${w2}`;
};

export const weekFileName = (name) => {
  if (!name || !DOC_EXT.test(name) || HAS_TAG.test(name)) return name;
  const cut = name.search(DOC_EXT);
  let stem = name.slice(0, cut);
  const ext = name.slice(cut);
  const days = [DATE, COMPACT].flatMap((rx) => [...stem.matchAll(rx)].map((m) => valid(m[1], m[2], m[3]))).filter(Boolean);
  if (days.length) {
    [DATE, COMPACT].forEach((rx) => { stem = stem.replace(rx, (m0, y, mo, d) => (valid(y, mo, d) ? '\0' : m0)); });
    while (JOIN.test(stem)) stem = stem.replace(JOIN, '\0');
    stem = stem.replace('\0', '\u0001').split('\0').join('');
    const t = tag(days);
    stem = stem.replace(/[-_ ]*\u0001[-_ ]*/, (m0, off) => `${off ? '-' : ''}${t}${off + m0.length < stem.length ? '-' : ''}`);
    return stem.replace(/[-_]{2,}/g, '-').replace(/^[-_ ]+|[-_ ]+$/g, '') + ext;
  }
  const months = [...stem.matchAll(MONTH)].map((m) => valid(m[1], m[2])).filter(Boolean);
  if (months.length) {
    const last = months.at(-1);
    return `${stem}-${tag([months[0], new Date(last.getFullYear(), last.getMonth() + 1, 0)])}${ext}`;
  }
  return `${stem}-${tag([new Date()])}${ext}`;
};
